// extracted by mini-css-extract-plugin
module.exports = {"img":"index-module--img--3hrLI","closeBtn":"index-module--closeBtn--20KgO"};